import TiclickTable from '@src/design-system/molecules/ticlick-table';

import {
  ReminderTemplatesActiveFilterChips,
  ReminderTemplatesTableFilterBtn,
} from '@src/features/reminders/components/reminder-templates-filters';

import { useReminderTemplatesTable } from './use-reminder-templates-table';

export function ReminderTemplatesTable() {
  const { table, toolbarActions } = useReminderTemplatesTable();

  return (
    <TiclickTable
      table={table}
      actions={toolbarActions}
      props={{ searchInputProps: { queryKey: 'name' } }}
      renderFilterBtn={() => <ReminderTemplatesTableFilterBtn />}
      toolbarExtra={<ReminderTemplatesActiveFilterChips />}
    />
  );
}
